(() => {
  function initGallery(gallery) {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const track = gallery.querySelector('.dp-gallery-track');
    const slides = [...track.children];
    const thumbnails = [...gallery.querySelectorAll('[data-photo]')];
    const counter = gallery.querySelector('[data-counter]');
    if (!slides.length) return;
    let active = 0;
    let scheduled = false;
    function sync() {
      active = Math.round(track.scrollLeft / track.clientWidth);
      active = Math.max(0, Math.min(active, slides.length - 1));
      thumbnails.forEach((button, index) => button.setAttribute('aria-pressed', String(index === active)));
      counter.textContent = `${active + 1} / ${slides.length}`;
      scheduled = false;
    }
    function go(index) {
      const target = (index + slides.length) % slides.length;
      track.scrollTo({left: target * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    gallery.querySelector('[data-prev]').addEventListener('click', () => go(active - 1));
    gallery.querySelector('[data-next]').addEventListener('click', () => go(active + 1));
    thumbnails.forEach((button, index) => button.addEventListener('click', () => go(index)));
    track.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1));
    });
    track.addEventListener('scroll', () => {
      if (!scheduled) { scheduled = true; requestAnimationFrame(sync); }
    }, {passive: true});
    new ResizeObserver(sync).observe(track);
    sync();
  }
  function initPurchase(purchase) {
    if (purchase.dataset.ready) return;
    purchase.dataset.ready = 'true';
    const select = purchase.querySelector('[data-variant]');
    const button = purchase.querySelector('[data-add]');
    const form = purchase.querySelector('form');
    const error = purchase.querySelector('[data-cart-error]');
    const success = purchase.querySelector('[data-cart-success]');
    const chips = purchase.querySelector('[data-variant-chips]');
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: purchase.dataset.currency || 'USD'});
    const format = cents => money.format(cents / 100);
    let submitting = false;
    chips.hidden = false;
    select.classList.add('dp-native-variant');
    function sync() {
      const option = select.selectedOptions[0];
      const compare = purchase.querySelector('[data-compare]');
      const price = Number(option.dataset.cents);
      const comparePrice = Number(option.dataset.compareCents);
      const quantity = Number(form.querySelector('[name="quantity"]:checked').value);
      purchase.querySelector('[data-price]').textContent = option.dataset.price;
      compare.textContent = option.dataset.compare;
      compare.hidden = !option.dataset.compare;
      const saving = purchase.querySelector('[data-saving]');
      saving.hidden = comparePrice <= price || price <= 0;
      saving.textContent = `Save ${format(comparePrice - price)}`;
      chips.querySelectorAll('[data-variant-id]').forEach(chip => chip.setAttribute('aria-pressed', String(chip.dataset.variantId === select.value)));
      purchase.querySelectorAll('[data-quantity-price]').forEach(el => el.textContent = format(price * Number(el.dataset.quantityPrice)));
      purchase.querySelectorAll('[data-quantity-compare]').forEach(el => { el.textContent = format(comparePrice * Number(el.dataset.quantityCompare)); el.hidden = comparePrice <= price || price <= 0; });
      purchase.querySelector('[data-total]').textContent = `${format(price * quantity)} ${purchase.dataset.currency}`;
      purchase.querySelector('[data-order-count]').textContent = `${quantity} ${quantity === 1 ? 'item' : 'items'}`;
      purchase.querySelector('[data-button-total]').textContent = format(price * quantity);
      button.disabled = submitting || option.dataset.buyable !== 'true';
      purchase.querySelector('[data-add-label]').textContent = submitting ? 'Adding…' : option.dataset.buyable === 'true' ? 'Add to cart' : 'Currently unavailable';
    }
    select.addEventListener('change', sync);
    chips.querySelectorAll('[data-variant-id]').forEach(chip => chip.addEventListener('click', () => { select.value = chip.dataset.variantId; sync(); }));
    form.querySelectorAll('[name="quantity"]').forEach(input => input.addEventListener('change', sync));
    purchase.querySelector('[data-continue]').addEventListener('click', () => { success.hidden = true; button.focus(); });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (submitting || select.selectedOptions[0].dataset.buyable !== 'true') return;
      const data = new FormData(form);
      submitting = true;
      error.hidden = true;
      success.hidden = true;
      button.setAttribute('aria-busy', 'true');
      sync();
      try {
        const response = await fetch(`${form.action.replace(/\/$/, '')}.js`, {method: 'POST', body: data, headers: {'Accept': 'application/json'}});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'This selection could not be added. Check its availability and try again.');
        purchase.querySelector('[data-cart-message]').textContent = `${data.get('quantity')} × ${result.product_title || result.title}`;
        success.hidden = false;
        success.focus();
      } catch (problem) {
        error.textContent = problem instanceof TypeError || problem instanceof SyntaxError ? 'We could not confirm the cart update. Check your cart before trying again.' : problem.message;
        error.hidden = false;
      } finally {
        submitting = false;
        button.removeAttribute('aria-busy');
        sync();
      }
    });
    sync();
  }
  function init(root) {
    root.querySelectorAll('[data-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-purchase]').forEach(initPurchase);
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
